import { createContext, useContext } from 'react';
import { PageView } from '@tomis-tech/types';
import { CustomBotIconHook } from '../../hooks/useCustomBotIcon';

import { BotParentPenpalMethods, SessionObject, NumberPair } from '../types';
import { View } from '../view';

interface ParentContextInterface extends BotParentPenpalMethods {
  parentWindowSize: NumberPair;
  isMobile: boolean;
  pageView: PageView;
}
export const ParentContext = createContext(null);
export const useParent = () =>
  useContext<ParentContextInterface>(ParentContext);

export const SessionContext = createContext(null);
export const useSession = () => useContext<SessionObject>(SessionContext);

export type ViewController = {
  currentView: View; // (animations react to this)
  transitionToView: (view: View) => void; // Gets called with the desired view
  settlePosition: () => void; // This is to be called when animation completes
  viewportOffset: NumberPair; // should be used directly in styling, will always reflect actual iframe size
  open: () => void;
  close: () => void;
};
export const ViewControllerContext = createContext(null);
export const useViewController = () =>
  useContext<ViewController>(ViewControllerContext);

type Typing = {
  isTyping: boolean;
  setIsTyping: (isTyping: boolean) => void;
};
export const TypingContext = createContext(null);
export const useTyping = () => useContext<Typing>(TypingContext);

export type CheckAvailabilityContextShape = {
  changingDates: boolean;
  changingProduct: boolean;
  changingQuantity: boolean;
  headerErrorMessage: string;
  setChangingDates: React.Dispatch<React.SetStateAction<boolean>>;
  setChangingProduct: React.Dispatch<React.SetStateAction<boolean>>;
  setChangingQuantity: React.Dispatch<React.SetStateAction<boolean>>;
  setHeaderErrorMessage: React.Dispatch<React.SetStateAction<string>>;
};

export const CheckAvailabilityContext = createContext(null);
export const useCheckAvailability = () =>
  useContext<CheckAvailabilityContextShape>(CheckAvailabilityContext);

/** If site uses custom bot icon, get downloadable URL from Firebase Storage */
export const CustomBotIconContext = createContext<CustomBotIconHook>({
  status: 'idle',
  url: null,
});
